
/**
 * Module dependencies.
 */

import { css } from 'styled-components';
import { media, units } from 'src/styles/utils';
import { theme } from 'styled-tools';

/**
 * Wide page padding.
 *
 * `Page Padding/padding-global` in the 2026 design system, defined at the
 * 1440px artboard.
 */

const widePagePadding = '123px';

/**
 * Export `pageHorizontalPadding`.
 *
 * The horizontal padding of the 2026 revamp sections: the project grid gutters
 * up to the design's own breakpoint, where it widens to the design value.
 */

export const pageHorizontalPadding = css`
  padding-left: ${theme('grid.gutterMobile')}px;
  padding-right: ${theme('grid.gutterMobile')}px;

  ${media.min('ms')`
    padding-left: ${theme('grid.gutter')}px;
    padding-right: ${theme('grid.gutter')}px;
  `}

  ${media.min('xl')`
    padding-left: ${widePagePadding};
    padding-right: ${widePagePadding};
  `}
`;

/**
 * Export `pageContainer`.
 *
 * `Container/container-large` in the 2026 design system.
 */

export const pageContainer = css`
  margin: 0 auto;
  max-width: ${units(160)};
  width: 100%;
`;
